<template>
  <div class="d-flex justify-space-between align-center pa-8">
    <div class="page-header-left">
      <slot name="left">
        <router-link
          class="text-decoration-none"
          :to="to"
        >
          <v-btn text>
            <v-icon>mdi-arrow-left</v-icon> {{ $t('Back') }}
          </v-btn>
        </router-link>
      </slot>
    </div>
    <span class="text-h5">
      <slot name="middle"></slot>
    </span>

    <div class="calendar-date-teller">
      <slot name="right">
        {{ dateTeller }}
      </slot>
    </div>
  </div>
</template>

<script>
import { format, getTime } from 'date-fns';
import { getLanguagePackFromBrowser } from '../helpers/language';

export default {
  props: {
    to: {
      type: Object,
      default: () => ({ name: 'member-list' }),
      required: false,
    },
  },
  computed: {
    dateTeller() {
      return format(getTime(Date.now()), 'do MMMM yyyy', { locale: getLanguagePackFromBrowser() });
    },
  },
};
</script>

<style langs="scss" scoped>
.calendar-date-teller {
  font-size: 30px;
  font-weight: bold;
  color: rgba(0, 0, 0, 0.5);
  flex: 1;
  flex-basis: 0;
  text-align: right;
}

.page-header-left {
  flex: 1;
  flex-basis: 0;
}
</style>
